import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { filter } from 'rxjs';
import { SidebarService } from './core/services/sidebar.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule, HttpClientModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'wealthLane-front';
  constructor(public translate: TranslateService,  private router: Router, private route: ActivatedRoute, private sidebarService: SidebarService) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('fr');   
  }
  switchLanguage(language: string) {
    this.translate.use(language);
  }  
}
